<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="agency-info-app-container">
    <form-data> </form-data>
  </div>
</template>

<script>
export default {
  name: 'AgencyInfo',
  components: {
    formData: () => import('@/views/ita/appManage/components/agencyDataForm.vue'),
  },
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style></style>
